import { render, staticRenderFns } from "./SupplierAgingOverviewTable.vue?vue&type=template&id=e859119c"
import script from "./SupplierAgingOverviewTable.vue?vue&type=script&lang=ts"
export * from "./SupplierAgingOverviewTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports